import(/* webpackMode: "eager", webpackExports: ["RelativeDate"] */ "/usr/local/src/rallly/apps/web/src/features/quick-create/components/relative-date.tsx");
;
import(/* webpackMode: "eager" */ "/usr/local/src/rallly/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/local/src/rallly/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/usr/local/src/rallly/packages/ui/src/button.tsx");
;
import(/* webpackMode: "eager" */ "/usr/local/src/rallly/packages/ui/src/icon.tsx");
